import { cva } from 'class-variance-authority';

export const pricingCardSectionStyle = cva(
  ['relative flex w-full flex-col justify-between gap-8 rounded-2xl bg-pricingCardGradient p-6 backdrop-blur'],
  {
    variants: {
      isHighlighted: {
        true: [
          'border-[3px] border-solid border-primary-200/30 before:absolute before:top-0 before:h-0.5 before:w-full before:bg-pricingCardGlow before:blur-sm',
        ],
        false: ['before:hidden'],
      },
    },
    defaultVariants: {
      isHighlighted: false,
    },
  },
);

export const pricingCardTitleStyle = cva('flex flex-col text-left font-spaceGrotesk text-display-sm font-semibold', {
  variants: {
    isHighlighted: {
      true: 'bg-textHighlightGradient bg-clip-text text-transparent',
      false: 'text-white',
    },
  },
});
